import { Avatar } from 'components/avatar/Avatar';
import { ASSETS_HOST } from 'constants/assets';

type Props = {
  league: {
    name: string;
    slug: string;
    avatarUrl?: string;
  };
  className?: string;
  size?: number;
};

const getLeagueAvatarUrl = (slug: string) =>
  `${ASSETS_HOST}/competition/picture/icons/${slug}.png`;

export const LeagueAvatar = ({
  league: { name, slug, avatarUrl: leagueAvatarurl },
  ...rest
}: Props) => {
  const avatarUrl = leagueAvatarurl || getLeagueAvatarUrl(slug);
  return <Avatar name={name} avatarUrl={avatarUrl} {...rest} />;
};
